import useLoad from 'components/hooks/useLoad';
import {integrityCollaborator} from 'constants/url';

function useLoadIntegrityCollaborator(selection: any) {
  return useLoad(integrityCollaborator, 'revision', {values: selection});
}

export default useLoadIntegrityCollaborator;
